function SecondDiagnosisExecutionWrapperVO(diagnosis, result1Number, result1Date, result1Place,
										   result2Number, result2Date, result2Place,
										   result3Number, result3Date, result3Place) {

	this.diagnosis = diagnosis;
	this.result1Number = result1Number;
	this.result1Date = result1Date;
	this.result1Place = result1Place;
	this.result2Number = result2Number;
	this.result2Date = result2Date;
	this.result2Place = result2Place;
	this.result3Number = result3Number;
	this.result3Date = result3Date;
	this.result3Place = result3Place;

	var _typeContext = {
		result1Date : Date,
		result2Date : Date,
		result3Date : Date
	};

	this._getType = function (property) {
		if (_typeContext.hasOwnProperty(property)) {
			return _typeContext[property];
		}
		else {
			return undefined;
		}
	};

	var _mappingContext = {};

	this._getMapping = function (property) {
		if (_mappingContext[property]) {
			return _mappingContext[property];
		}
		else {
			return undefined;
		}
	};
}
